var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-plus2';
                    var viewUrl = 'sprite.svg#view-icon-plus2';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };